<template>
  <div class="d-flex align-center col-12 px-0">
    <v-col cols="6" class="d-flex align-center">
      <v-btn
        v-if="!participantHorseList[index].participant && isSessionGroupe"
        plain
        rounded
        large
        class="ml-6 mr-1"
        :disabled="!canUserPerformAction"
        @click="addAnonimosHorseRider()"
      >
        <v-icon color="black">mdi-incognito</v-icon>
      </v-btn>
      <v-col v-else-if="content.notInSession" class="d-flex align-center my-2" style="height: 68px;">
        {{ content.participantFullname }} ({{ numberOfClubParticipants }})
      </v-col>
      <ParticipantHorseListResources
        v-else
        v-model="selectedParticipants"
        class="flex-grow-1"
        :index="index"
        icon="mdi-account-plus"
        :content="content"
        wtype="participant"
        content-type-field="fullname"
        :available="computedSessionParticipants || []"
        :session="session"
        :content-types="computedSessionParticipants || []"
        field="uuid"
        :number-of-club-participants="numberOfClubParticipants"
      />
    </v-col>
    <v-col    
      cols="1"
      class="text-center"
    >
      <v-icon
        v-if="!content.notInSession && isEquestrianSession"
        color="black"
      >
        mdi-code-tags
      </v-icon>
    </v-col>
    <v-col :cols="horseColsSize">
      <ParticipantHorseListResources
        v-if="!content.notInSession && isEquestrianSession"
        :index="index"
        icon="mdi-plus"
        :content="content"
        wtype="horse"
        content-type-field="horse_name"
        :available="availableHorses"
        :session="session"
        :content-types="horses"
        field="uuid"
        :number-of-club-participants="numberOfClubParticipants"
      />
    </v-col>
    <v-col v-if="hasClubMembers(content)" cols="1">
      <v-btn 
        icon 
        small 
        @click="toggleExpansion(content.contract_number)"
      >
        <v-icon size="32">
          {{ isClubExpanded(content.contract_number) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </v-btn>
    </v-col>
  </div>
</template>

<script>
import { inject, computed } from '@vue/composition-api';
import store from '@/store';
import { equestrianSession } from '@/helpers/sessions';

import { updateSessionAmplify } from '../../helpers/amplify';

import ParticipantHorseListResources from '@/components/ParticipantHorse/ParticipantHorseListResources.vue';
export default {
  name: 'ResourceHorseListItem',
  components: {
    ParticipantHorseListResources
  },
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: -1
    },
    horses: {
      type: Array,
      default: () => []
    },
    availableHorses: {
      type: Array,
      default: () => []
    },
    session: {
      type: Object,
      default: () => ({})
    },
    selectedParticipants: {
      type: Array,
      default: () => []
    },
    isClubExpanded: {
      type: Function,
      default: () => () => {}
    },
    calculateCustomerAge: {
      type: Function,
      default: () => () => {}
    },
    numberOfClubParticipants: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);
    const isSessionGroupe = computed(() => props.session.type === 'GROUPE');
    
    const participantHorseList = inject('participantHorseList');
    const isComponentLoading = inject('isComponentLoading');
    const isEquestrianSession = computed(() => equestrianSession(props.session.type));

    const computedSessionParticipants = computed(() => (props.session.participants || []).map(p => {
      const participant = { ...p };

      // participant.paymentColor = customerPaymentStatus(participant.uuid);
      participant.age = props.calculateCustomerAge(participant.uuid);
      participant.fullname = `${participant.firstname} ${participant.lastname}`;
      return participant;
    }));
    
    const getNextAvailableIndex = (participants) => {
      let index = 1;
      while (participants.some(p => p.uuid === `customer_id_${props.session.id}_${index}`)) {
        index++;
      }
      return index;
    }
    const addAnonimosHorseRider = async () => {
      const objectSession = { ...props.session };
      const horseIndex = (objectSession.horses || []).findIndex(h => h.uuid === props.content?.horse);
      
      const firstAvailableIndex = getNextAvailableIndex(objectSession.participants);

      objectSession.participants.push({
        contract_number: null,
        firstname: 'Inconnue',
        horanet_id: `horanet_id_${props.session.id}_${firstAvailableIndex}`,
        horse: horseIndex !== -1 ? objectSession.horses[horseIndex].uuid : null,
        lastname: `client + ${firstAvailableIndex}`,
        presence: false,
        qrcode: null,
        uuid: `customer_id_${props.session.id}_${firstAvailableIndex}`,
        isAnnonymousCustomer: true,
        wtype: 'customer'
      });

      isComponentLoading.value = true;
      await updateSessionAmplify(objectSession);
      isComponentLoading.value = false;
    };

    const clubParticipantExists = computed(() => (participantHorseList.value || []).some(p => p.isClubParticipant && !p.contractOwner));

    const horseColsSize = computed(() => (clubParticipantExists.value ? 4 : 5));

    const toggleExpansion = (contractNumber) => {
      emit('toggle-expansion', contractNumber);
    };

    const hasClubMembers = (contractOwner) => {
      if (!contractOwner || !contractOwner.contractOwner) return false;
      return (participantHorseList.value || []).some(p => p.isClubParticipant && !p.contractOwner && p.contract_number.toString() === contractOwner.contract_number.toString());
    };
    
    return {
      participantHorseList,
      computedSessionParticipants,
      isSessionGroupe,
      toggleExpansion,
      hasClubMembers,
      horseColsSize,
      canUserPerformAction,
      addAnonimosHorseRider,
      isEquestrianSession
    }
  }
};
</script>

<style scoped>

</style>